import type { Components, Theme } from "@mui/material/styles";

export const MuiFormLabel: Components<Theme>["MuiFormLabel"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: theme.typography.fontSizeMd,
      // disable pointer-events because the z-index will cause them to be captured
      pointerEvents: "none",
      // the label is the first child, but it needs to be on top of any background
      zIndex: 1,

      "&.Mui-error": {
        color:
          1000 in theme.palette.error ? theme.palette.error[1000] : undefined,
      },
    }),
  },
};
